import { isIdMatch, type AdminUser, type User } from '@hero/schema';

export const getSentryUser = (user: User) => {
  const targetOrg = user.orgs.find(
    org => user.currentSignedInOrgId && isIdMatch(org._id, user.currentSignedInOrgId),
  );
  return {
    id: user._id.toString(),
    name: user.name,
    phone: user.phone,
    preferredLanguage: user.preferredLanguage,
    orgId: user.currentSignedInOrgId?.toString(),
    orgName: targetOrg?.name,
    orgType: targetOrg?.target,
    orgsCount: user.orgs.length,
    orgs: user.orgs,
    // Auth-v2: network identity via `roles[]`. In-org permission via
    // `orgs[i].memberType`.
    roles: user.roles,
    memberType: targetOrg?.memberType,
    userMainType: user.roles[0] ?? 'individual_customer',
  };
};

/** Admin-panel staff identity for Sentry Issues / Replays (no network orgs). */
export const getSentryAdminUser = (user: AdminUser) => {
  return {
    id: user._id.toString(),
    name: user.name,
    email: user.email,
    phone: user.phone,
    preferredLanguage: user.preferredLanguage,
    permissions: user.permissions,
    status: user.status,
    memberType: 'admin' as const,
    userMainType: 'admin' as const,
  };
};
